/**
 * TextNode — Plain text block with context menu
 */

import { useState, useRef, useEffect } from 'react';
import { Handle, Position } from '@xyflow/react';

export default function TextNode({ data, selected, id }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(data.content || '');
  const [showMenu, setShowMenu] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { setText(data.content || ''); }, [data.content]);
  useEffect(() => { if (editing && inputRef.current) inputRef.current.focus(); }, [editing]);

  return (
    <div className={`bg-white rounded-lg border ${selected ? 'border-blue-500 shadow-md' : 'border-gray-200'} p-3 min-w-[120px] group relative`}
      onDoubleClick={() => setEditing(true)}>
      <Handle type="target" position={Position.Top} className="!w-2 !h-2 !bg-gray-400" />
      <Handle type="source" position={Position.Bottom} className="!w-2 !h-2 !bg-gray-400" />

      {/* Menu */}
      <div className="absolute top-1 right-1 z-10">
        <button onClick={(e) => { e.stopPropagation(); setShowMenu(!showMenu); }}
          className="p-1 rounded opacity-0 group-hover:opacity-100 hover:bg-black/10 transition-opacity">
          <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>
        </button>
        {showMenu && (
          <>
            <div className="fixed inset-0 z-20" onClick={() => setShowMenu(false)} />
            <div className="absolute right-0 top-6 w-32 bg-white rounded-lg shadow-xl border border-gray-200 py-1 z-30">
              <button onClick={() => { setEditing(true); setShowMenu(false); }}
                className="w-full px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50 text-left">Edit</button>
              <button onClick={() => { data.onDelete?.(id); setShowMenu(false); }}
                className="w-full px-3 py-1.5 text-xs text-red-600 hover:bg-red-50 text-left">Delete</button>
            </div>
          </>
        )}
      </div>

      {editing ? (
        <textarea ref={inputRef} value={text}
          onChange={e => setText(e.target.value)}
          onBlur={() => { setEditing(false); data.onContentChange?.(id, text); }}
          className="w-full bg-transparent text-sm text-gray-700 resize-none border-none outline-none"
          style={{ minHeight: 40 }} />
      ) : (
        <div className="text-sm text-gray-700 whitespace-pre-wrap cursor-text">
          {data.content || <span className="text-gray-400 italic">Double-click to edit</span>}
        </div>
      )}
    </div>
  );
}
